

// import React, { useState, useEffect, useRef, useMemo } from "react";
// import L from "leaflet";
// import "leaflet/dist/leaflet.css";
// import "leaflet-routing-machine";
// import * as turf from "@turf/turf";
// import { Form, Button, Col, Row, Table, FormCheck, FormSelect, Alert, ListGroup } from "react-bootstrap";
// import { X, CloudRain, Thermometer, Snowflake, Wind as WindIcon } from "lucide-react";

// const AssistanceOnMove = () => {
//   const mapRef = useRef(null);
//   const routeLayerRef = useRef(null);
//   const eventSegmentRef = useRef(null);
//   const routingControlRef = useRef(null);
//   const startMarkerRef = useRef(null);
//   const endMarkerRef = useRef(null);
//   const hospitalLayerRef = useRef(null);
//   const sucoLayerRef = useRef(null);
//   const [startLocation, setStartLocation] = useState("");
//   const [endLocation, setEndLocation] = useState("");
//   const [eventInfo, setEventInfo] = useState(null);
//   const [savedRoutes, setSavedRoutes] = useState([]);
//   const [healthFacilities, setHealthFacilities] = useState(null);
//   const [showHospitals, setShowHospitals] = useState(false);
//   const [routeGeoJSON, setRouteGeoJSON] = useState(null);
//   const [weatherData, setWeatherData] = useState([]);
//   const [sucoGeoJSON, setSucoGeoJSON] = useState(null);
//   const [selectedWeatherLayer, setSelectedWeatherLayer] = useState("none");
//   const [weatherWarnings, setWeatherWarnings] = useState([]);

//   const events = useMemo(
//     () => [
//       {
//         id: 1,
//         name: "Landslide",
//         description: "Be cautious, as the route you are traveling to is prone to landslide.",
//         location: [-8.8747, 125.5199],
//         radius: 2000,
//       },
//       {
//         id: 2,
//         name: "Cyclone",
//         description: "Be cautious, as the route you are traveling to is prone to cyclone.",
//         location: [-9.1747, 125.5199],
//         radius: 9000,
//       },
//     ],
//     []
//   );

//   // const today = "2025-09-15"; // Updated to current date: September 10, 2025
//   const today = new Date().toLocaleDateString('en-CA', {
//   timeZone: 'Asia/Dili' // Timor-Leste time zone
// });

//   useEffect(() => {
//     const map = L.map("map").setView([-8.9747, 125.5275], 9);
//     mapRef.current = map;

//     L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
//       maxZoom: 19,
//     }).addTo(map);

//     events.forEach((event) => {
//       L.circle(event.location, {
//         color: "red",
//         fillColor: "#f03",
//         fillOpacity: 0.5,
//         radius: event.radius,
//       }).addTo(map);
//     });

//     // Fetch health facilities
//     fetch("/Healthfacilities.geojson")
//       .then((response) => response.json())
//       .then((data) => setHealthFacilities(data))
//       .catch((error) => console.error("Error loading health facilities:", error));

//     // Fetch weather forecast data
//     fetch("https://drr-dss-backend.rimes.int/ecmwf/forecast/5_days_suco/")
//       .then((response) => response.json())
//       .then((data) => setWeatherData(data))
//       .catch((error) => console.error("Error loading weather data:", error));

//     // Fetch suco GeoJSON
//     fetch("/DATA/OSMbased_adm3_boundary.json")
//       .then((response) => response.json())
//       .then((data) => setSucoGeoJSON(data))
//       .catch((error) => console.error("Error loading suco GeoJSON:", error));

//     return () => map.remove();
//   }, [events]);

//   useEffect(() => {
//     if (sucoGeoJSON && weatherData.length > 0 && mapRef.current && selectedWeatherLayer !== "none") {
//       addSucoWeatherLayer();
//     } else if (sucoLayerRef.current) {
//       mapRef.current.removeLayer(sucoLayerRef.current);
//       sucoLayerRef.current = null;
//     }
//   }, [selectedWeatherLayer, sucoGeoJSON, weatherData]);

//   const addSucoWeatherLayer = () => {
//     if (sucoLayerRef.current) {
//       mapRef.current.removeLayer(sucoLayerRef.current);
//     }

//     const layerToParam = {
//       heatwave: "max_temp",
//       coldwave: "min_temp",
//       rainfall: "rainfall",
//       wind: "wind_speed",
//       combined: "combined",
//     };

//     const param = layerToParam[selectedWeatherLayer];

//     sucoLayerRef.current = L.geoJSON(sucoGeoJSON, {
//       style: (feature) => {
//         const admCode = feature.properties.ADM_Code.toString();
//         const record = weatherData.find((r) => r.adm_code === admCode && r.fcst_date === today);
//         const color = getWeatherColor(record, param);
//         return {
//           fillColor: color,
//           fillOpacity: color === "transparent" ? 0 : 0.7,
//           color: "transparent",
//           weight: 0,
//           opacity: 0,
//         };
//       },
//       onEachFeature: (feature, layer) => {
//         const admCode = feature.properties.ADM_Code.toString();
//         const record = weatherData.find((r) => r.adm_code === admCode && r.fcst_date === today);
//         if (record) {
//           const tooltipContent = `
//             <b>Suco: ${feature.properties.ADM3}</b><br>
//             Rainfall: ${record.rainfall} mm<br>
//             Max Temp: ${record.max_temp} °C<br>
//             Min Temp: ${record.min_temp} °C<br>
//             Wind Speed: ${record.wind_speed} km/h
//           `;
//           layer.bindTooltip(tooltipContent, { sticky: true });
//         }
//       },
//     }).addTo(mapRef.current);
//   };

//   const getWeatherColor = (record, param) => {
//     if (!record) return "transparent";

//     const max_temp = record.max_temp;
//     const min_temp = record.min_temp;
//     const rainfall = record.rainfall;
//     const wind_speed = record.wind_speed;

//     if (param === "max_temp") {
//       return max_temp > 30 ? "red" : "transparent";
//     } else if (param === "min_temp") {
//       return min_temp < 10 ? "blue" : "transparent";
//     } else if (param === "rainfall") {
//       return rainfall > 3 ? "purple" : "transparent";
//     } else if (param === "wind_speed") {
//       return wind_speed > 10 ? "orange" : "transparent";
//     } else if (param === "combined") {
//       if (max_temp > 30) return "red";
//       if (min_temp < 10) return "blue";
//       if (rainfall > 3) return "purple";
//       if (wind_speed > 10) return "orange";
//       return "transparent";
//     }
//     return "transparent";
//   };

//   const geocode = async (location) => {
//     const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(location)}`;
//     try {
//       const response = await fetch(url);
//       const data = await response.json();
//       return data.length > 0 ? { lat: parseFloat(data[0].lat), lon: parseFloat(data[0].lon) } : null;
//     } catch (error) {
//       console.error("Geocoding error:", error);
//       return null;
//     }
//   };

//   const findRoute = async () => {
//     if (!mapRef.current) return;
//     try {
//       const startCoords = await geocode(startLocation);
//       const endCoords = await geocode(endLocation);
//       if (!startCoords || !endCoords) throw new Error("Invalid locations");

//       // Clear existing layers
//       if (routeLayerRef.current) mapRef.current.removeLayer(routeLayerRef.current);
//       if (eventSegmentRef.current) mapRef.current.removeLayer(eventSegmentRef.current);
//       if (routingControlRef.current) mapRef.current.removeControl(routingControlRef.current);
//       if (startMarkerRef.current) mapRef.current.removeLayer(startMarkerRef.current);
//       if (endMarkerRef.current) mapRef.current.removeLayer(endMarkerRef.current);
//       if (hospitalLayerRef.current) mapRef.current.removeLayer(hospitalLayerRef.current);

//       setEventInfo(null);
//       setWeatherWarnings([]);
//       setShowHospitals(false);

//       // Add start marker
//       const startMarker = L.marker([startCoords.lat, startCoords.lon], {
//         icon: L.icon({
//           iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png",
//           iconSize: [25, 41],
//           iconAnchor: [12, 41],
//           popupAnchor: [1, -34],
//           shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
//           shadowSize: [41, 41],
//         }),
//       }).addTo(mapRef.current);
//       startMarker.bindPopup(`Start: ${startLocation}`).openPopup();
//       startMarkerRef.current = startMarker;

//       // Add end marker
//       const endMarker = L.marker([endCoords.lat, endCoords.lon], {
//         icon: L.icon({
//           iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png",
//           iconSize: [25, 41],
//           iconAnchor: [12, 41],
//           popupAnchor: [1, -34],
//           shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
//           shadowSize: [41, 41],
//         }),
//       }).addTo(mapRef.current);
//       endMarker.bindPopup(`End: ${endLocation}`).openPopup();
//       endMarkerRef.current = endMarker;

//       generateRoute(startCoords, endCoords);
//     } catch (error) {
//       alert(error.message);
//     }
//   };

//   const generateRoute = (start, end) => {
//     const control = L.Routing.control({
//       waypoints: [L.latLng(start.lat, start.lon), L.latLng(end.lat, end.lon)],
//       createMarker: () => null,
//       routeWhileDragging: false,
//       draggableWaypoints: false,
//     }).addTo(mapRef.current);

//     routingControlRef.current = control;

//     control.on("routesfound", async (e) => {
//       const routeCoords = e.routes[0].coordinates.map((coord) => [coord.lng, coord.lat]);
//       const routeLine = turf.lineString(routeCoords);
//       setRouteGeoJSON(routeLine);

//       const totalDistance = turf.length(routeLine, { units: "kilometers" }).toFixed(2);

//       let eventData = null;

//       for (const event of events) {
//         const eventGeoJSON = turf.circle([event.location[1], event.location[0]], event.radius / 1000, { units: "kilometers" });
//         if (turf.booleanIntersects(routeLine, eventGeoJSON)) {
//           const intersectPoints = turf.lineIntersect(routeLine, eventGeoJSON);
//           if (intersectPoints.features.length >= 2) {
//             const entryUrl = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${intersectPoints.features[0].geometry.coordinates[1]}&lon=${intersectPoints.features[0].geometry.coordinates[0]}`;
//             const exitUrl = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${intersectPoints.features[1].geometry.coordinates[1]}&lon=${intersectPoints.features[1].geometry.coordinates[0]}`;

//             const [entryResponse, exitResponse] = await Promise.all([fetch(entryUrl), fetch(exitUrl)]);
//             const entryData = await entryResponse.json();
//             const exitData = await exitResponse.json();

//             const entryPlaceName = entryData.display_name || "Unknown location";
//             const exitPlaceName = exitData.display_name || "Unknown location";

//             const startToEventDistance = turf.distance(
//               turf.point([start.lon, start.lat]),
//               turf.point(intersectPoints.features[0].geometry.coordinates),
//               { units: "kilometers" }
//             ).toFixed(2);

//             eventData = {
//               ...event,
//               entry: intersectPoints.features[0].geometry.coordinates,
//               exit: intersectPoints.features[1].geometry.coordinates,
//               entryPlace: entryPlaceName,
//               exitPlace: exitPlaceName,
//               travelDistance: turf.distance(
//                 turf.point(intersectPoints.features[0].geometry.coordinates),
//                 turf.point(intersectPoints.features[1].geometry.coordinates),
//                 { units: "kilometers" }
//               ).toFixed(2),
//               startToEventDistance: startToEventDistance,
//               totalDistance: totalDistance,
//             };
//             break;
//           }
//         }
//       }

//       // Find weather warnings along route
//       const warnings = [];
//       if (sucoGeoJSON) {
//         const intersectingSucos = sucoGeoJSON.features.filter((feature) =>
//           turf.booleanIntersects(routeLine, turf.feature(feature.geometry))
//         );

//         intersectingSucos.forEach((suco) => {
//           const admCode = suco.properties.ADM_Code.toString();
//           const record = weatherData.find((r) => r.adm_code === admCode && r.fcst_date === today);
//           if (record) {
//             if (record.max_temp > 30) {
//               warnings.push({
//                 type: "heatwave",
//                 message: `Heatwave alert in ${suco.properties.ADM3} (Max Temp: ${record.max_temp}°C)`,
//                 icon: Thermometer,
//               });
//             }
//             if (record.min_temp < 10) {
//               warnings.push({
//                 type: "coldwave",
//                 message: `Cold wave alert in ${suco.properties.ADM3} (Min Temp: ${record.min_temp}°C)`,
//                 icon: Snowflake,
//               });
//             }
//             if (record.rainfall > 3) {
//               warnings.push({
//                 type: "rainfall",
//                 message: `Heavy rainfall alert in ${suco.properties.ADM3} (Rainfall: ${record.rainfall}mm)`,
//                 icon: CloudRain,
//               });
//             }
//             if (record.wind_speed > 10) {
//               warnings.push({
//                 type: "wind",
//                 message: `Heavy wind alert in ${suco.properties.ADM3} (Wind Speed: ${record.wind_speed}km/h)`,
//                 icon: WindIcon,
//               });
//             }
//           }
//         });
//       }
//       setWeatherWarnings(warnings);

//       if (eventData) {
//         setEventInfo({ ...eventData, startLocation, endLocation });
//         eventSegmentRef.current = L.polyline([eventData.entry.reverse(), eventData.exit.reverse()], {
//           color: "red",
//           weight: 4,
//         }).addTo(mapRef.current);
//       } else {
//         setEventInfo({ startLocation, endLocation, totalDistance });
//       }

//       routeLayerRef.current = L.polyline(routeCoords.map(([lng, lat]) => [lat, lng]), {
//         color: "#333",
//         weight: 4,
//       }).addTo(mapRef.current);
//     });
//   };

//   const toggleHospitals = () => {
//     if (!healthFacilities || !routeGeoJSON) return;

//     if (hospitalLayerRef.current) {
//       mapRef.current.removeLayer(hospitalLayerRef.current);
//       hospitalLayerRef.current = null;
//     }

//     setShowHospitals(!showHospitals);

//     if (!showHospitals) {
//       const nearbyHospitals = turf.featureCollection(
//         healthFacilities.features.filter((feature) => {
//           const coordinates = feature.geometry?.coordinates;
//           if (!Array.isArray(coordinates) || coordinates.length !== 2) return false;

//           const parsedCoordinates = coordinates.map((coord) => parseFloat(coord));
//           if (parsedCoordinates.some(isNaN)) return false;

//           const hospitalPoint = turf.point(parsedCoordinates);
//           const hospitalBuffer = turf.buffer(hospitalPoint, 1, { units: "kilometers" });

//           return turf.booleanIntersects(hospitalBuffer, routeGeoJSON);
//         })
//       );

//       hospitalLayerRef.current = L.geoJSON(nearbyHospitals, {
//         pointToLayer: (feature, latlng) => {
//           return L.marker(latlng, {
//             icon: L.icon({
//               iconUrl: "/Roadaccidenticons/yellow.png",
//               iconSize: [15, 15],
//               iconAnchor: [12, 41],
//               popupAnchor: [1, -34],
//             }),
//           }).bindPopup(feature.properties?.HF_NAME || "Health Facility");
//         },
//       }).addTo(mapRef.current);
//     }
//   };

//   const saveRouteInfo = () => {
//     if (!eventInfo) return;

//     const newRoute = {
//       startLocation: eventInfo.startLocation,
//       endLocation: eventInfo.endLocation,
//       dateTime: new Date().toLocaleString(),
//       totalDistance: eventInfo.totalDistance,
//       affectedPath: eventInfo.entryPlace && eventInfo.exitPlace
//         ? `${eventInfo.entryPlace} - ${eventInfo.exitPlace}`
//         : "N/A",
//       distanceToAffected: eventInfo.startToEventDistance || "N/A",
//       weatherWarnings: weatherWarnings.map((w) => w.message).join("; "),
//     };

//     setSavedRoutes((prevRoutes) => [...prevRoutes, newRoute]);
//     setEventInfo(null);
//     setWeatherWarnings([]);
//   };

//   return (
//     <div className="mapcontainerall" style={{ padding: "20px", backgroundColor: "#f8f9fa", borderRadius: "8px" }}>
//       <div className="formcontainer1" style={{ marginBottom: "20px" }}>
//         <Form>
//           <Row className="align-items-center">
//             <Col md={3}>
//               <Form.Control
//                 type="text"
//                 value={startLocation}
//                 onChange={(e) => setStartLocation(e.target.value)}
//                 placeholder="Start Location"
//               />
//             </Col>
//             <Col md={3}>
//               <Form.Control
//                 type="text"
//                 value={endLocation}
//                 onChange={(e) => setEndLocation(e.target.value)}
//                 placeholder="End Location"
//               />
//             </Col>
//             <Col md={2}>
//               <FormSelect value={selectedWeatherLayer} onChange={(e) => setSelectedWeatherLayer(e.target.value)}>
//                 <option value="none">No Weather Layer</option>
//                 <option value="heatwave">Heatwave Layer</option>
//                 <option value="coldwave">Cold Wave Layer</option>
//                 <option value="rainfall">Rainfall Layer</option>
//                 <option value="wind">Wind Layer</option>
//                 <option value="combined">Combined Weather Layer</option>
//               </FormSelect>
//             </Col>
//             <Col md={2}>
//               <Button variant="primary" onClick={findRoute} style={{ width: "100%" }}>
//                 Find Route
//               </Button>
//             </Col>
//           </Row>
//         </Form>
//       </div>
//       <div style={{ position: "relative" }}>
//         <div
//           style={{
//             position: "absolute",
//             bottom: "10px",
//             left: "10px",
//             zIndex: 1000,
//             background: "white",
//             padding: "10px",
//             borderRadius: "8px",
//             boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
//           }}
//         >
//           <FormCheck
//             type="checkbox"
//             label="Show Nearby Hospitals"
//             checked={showHospitals}
//             onChange={toggleHospitals}
//             disabled={!routeGeoJSON || !healthFacilities}
//           />
//         </div>
//         <div id="map" style={{ height: "65vh", marginBottom: "20px", borderRadius: "8px" }}></div>
//       </div>
//       {eventInfo && (
//         <Alert
//           variant="info"
//           style={{
//             marginBottom: "20px",
//             borderRadius: "8px",
//             boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
//           }}
//         >
//           <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//             <h5>Route Information</h5>
//             <X size={20} style={{ cursor: "pointer" }} onClick={() => setEventInfo(null)} />
//           </div>
//           <p>
//             <strong>Route:</strong> {eventInfo.startLocation} → {eventInfo.endLocation} (Total distance: {eventInfo.totalDistance} km)
//           </p>
//           {eventInfo.description && (
//             <>
//               <p><strong>Event Alert:</strong> {eventInfo.description}</p>
//               <p><strong>Distance to Event:</strong> {eventInfo.startToEventDistance} km</p>
//               <p><strong>Affected Path:</strong> {eventInfo.entryPlace} - {eventInfo.exitPlace}</p>
//               <p><strong>Distance through Event:</strong> {eventInfo.travelDistance} km</p>
//             </>
//           )}
//           {weatherWarnings.length > 0 && (
//             <div>
//               <h6>Weather Warnings Along Route:</h6>
//               <ListGroup>
//                 {weatherWarnings.map((warning, index) => (
//                   <ListGroup.Item key={index} variant="warning">
//                     <warning.icon size={16} className="me-2" />
//                     {warning.message}
//                   </ListGroup.Item>
//                 ))}
//               </ListGroup>
//             </div>
//           )}
//           <Button variant="success" size="sm" onClick={saveRouteInfo} style={{ marginTop: "10px" }}>
//             Save Route Info
//           </Button>
//         </Alert>
//       )}
//       <div style={{ marginTop: "20px" }}>
//         <h4>Saved Routes</h4>
//         <Table striped bordered hover responsive>
//           <thead>
//             <tr>
//               <th>S.No</th>
//               <th>Start Location</th>
//               <th>End Location</th>
//               <th>Date & Time</th>
//               <th>Total Distance (km)</th>
//               <th>Affected Path</th>
//               <th>Distance to Affected (km)</th>
//               <th>Weather Warnings</th>
//             </tr>
//           </thead>
//           <tbody>
//             {savedRoutes.map((route, index) => (
//               <tr key={index}>
//                 <td>{index + 1}</td>
//                 <td>{route.startLocation}</td>
//                 <td>{route.endLocation}</td>
//                 <td>{route.dateTime}</td>
//                 <td>{route.totalDistance}</td>
//                 <td>{route.affectedPath}</td>
//                 <td>{route.distanceToAffected}</td>
//                 <td>{route.weatherWarnings || "None"}</td>
//               </tr>
//             ))}
//           </tbody>
//         </Table>
//       </div>
//     </div>
//   );
// };

// export default AssistanceOnMove;



import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import axios from "axios";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-routing-machine";
import * as turf from "@turf/turf";
import { Form, Button, Col, Row, FormCheck } from "react-bootstrap";
import { CloudRain, Thermometer, Snowflake, Droplets } from "lucide-react";
import { onActiveEventsUpdated } from "../../../../utils/activeEventsBus";
const backendUrl = process.env.REACT_APP_BACKEND_API_URL_LOCAL;

// An active event's "impact area" for route-intersection purposes: use the
// felt-report geometry as-is when the reporter drew one (Polygon/LineString),
// otherwise buffer the point by a reasonable default radius.
const buildEventArea = (event, turf) => {
  const geometry = event.geometry;
  if (geometry?.type === "Polygon") return turf.polygon(geometry.coordinates);
  if (geometry?.type === "LineString") return turf.buffer(turf.lineString(geometry.coordinates), 1, { units: "kilometers" });
  if (geometry?.type === "Point") return turf.buffer(turf.point(geometry.coordinates), 5, { units: "kilometers" });
  if (event.lat != null && event.lon != null) return turf.buffer(turf.point([event.lon, event.lat]), 5, { units: "kilometers" });
  return null;
};

// Autosuggest text input for the Start/End location fields: suggests
// municipality / sub-municipality / suco names as the user types, and fills
// in the full admin hierarchy (e.g. "Becora, Cristo Rei, Dili, Timor-Leste")
// on selection so the Nominatim geocode call resolves accurately.
const LocationAutosuggest = ({ value, onChange, placeholder, suggestions, style }) => {
  const [showSuggestions, setShowSuggestions] = useState(false);
  const containerRef = useRef(null);

  const matches = useMemo(() => {
    const query = value.trim().toLowerCase();
    if (!query) return [];
    return suggestions
      .filter((item) => item.label.toLowerCase().includes(query))
      .slice(0, 8);
  }, [value, suggestions]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={containerRef} style={{ position: "relative", width: "100%" }}>
      <Form.Control
        type="text"
        value={value}
        onChange={(e) => {
          onChange(e.target.value);
          setShowSuggestions(true);
        }}
        onFocus={() => setShowSuggestions(true)}
        placeholder={placeholder}
        style={style}
        autoComplete="off"
      />
      {showSuggestions && matches.length > 0 && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            zIndex: 1500,
            background: "white",
            border: "1px solid #ced4da",
            borderRadius: "6px",
            marginTop: "2px",
            maxHeight: "220px",
            overflowY: "auto",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          }}
        >
          {matches.map((item, index) => (
            <div
              key={index}
              onMouseDown={(e) => {
                e.preventDefault();
                onChange(item.searchText);
                setShowSuggestions(false);
              }}
              style={{
                padding: "8px 12px",
                fontSize: "0.85em",
                cursor: "pointer",
                borderBottom: index !== matches.length - 1 ? "1px solid #f1f1f1" : "none",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f8f9fa")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "white")}
            >
              {item.label}
              <span style={{ color: "#9ca3af", fontSize: "0.85em" }}> — {item.levelLabel}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const AssistanceOnMove = () => {
  const mapRef = useRef(null);
  const routeLayerRef = useRef(null);
  const eventSegmentRef = useRef(null);
  const routingControlRef = useRef(null);
  const hospitalLayerRef = useRef(null);
  const sucoLayerRef = useRef(null);
  const [startLocation, setStartLocation] = useState("");
  const [endLocation, setEndLocation] = useState("");
  const [routeInfo, setRouteInfo] = useState(null);
  const [eventInfo, setEventInfo] = useState(null);
  const [healthFacilities, setHealthFacilities] = useState([]);
  const [showHospitals, setShowHospitals] = useState(false);
  const [nearbyHospitals, setNearbyHospitals] = useState([]);
  const [, setRouteGeoJSON] = useState(null);
  const [weatherData, setWeatherData] = useState({});
  const [sucoGeoJSON, setSucoGeoJSON] = useState(null);
  const [selectedWeatherLayer, setSelectedWeatherLayer] = useState("none");
  const [weatherWarnings, setWeatherWarnings] = useState([]);
  const [showInfoPanel, setShowInfoPanel] = useState(false);
  const [locationSuggestions, setLocationSuggestions] = useState([]);
  const [activeEvents, setActiveEvents] = useState([]);
  const activeEventsLayerRef = useRef(null);

  // Real last-24h active events (cyclone, landslide, earthquake, flood, fire
  // risk, lightning, road accident felt-reports) — same /common/active-events/
  // API and live-update mechanism the Active Events dashboard panel uses —
  // replacing the previous hardcoded dummy Landslide/Cyclone circles.
  useEffect(() => {
    const fetchActiveEvents = async () => {
      try {
        const response = await fetch(`${backendUrl}common/active-events/`);
        if (!response.ok) throw new Error(`Failed to fetch active events (status ${response.status})`);
        const data = await response.json();
        setActiveEvents(data.events || []);
      } catch (error) {
        console.error("Error loading active events:", error);
        setActiveEvents([]);
      }
    };
    fetchActiveEvents();
    const unsubscribe = onActiveEventsUpdated(fetchActiveEvents);
    return unsubscribe;
  }, []);
  // Municipality / sub-municipality / suco names for the Start/End location autosuggest.
  useEffect(() => {
    Promise.all([
      axios.post(`${backendUrl}Municipalities/municipalities_list/`),
      axios.post(`${backendUrl}Municipalities/sub_municipalities_list/`),
      axios.post(`${backendUrl}Municipalities/suco_list/`),
    ])
      .then(([municipalitiesRes, subMunicipalitiesRes, sucosRes]) => {
        const municipalities = municipalitiesRes.data.map((m) => ({
          label: m.adm1,
          levelLabel: "Municipality",
          searchText: `${m.adm1}, Timor-Leste`,
        }));
        const subMunicipalities = subMunicipalitiesRes.data.map((sm) => ({
          label: `${sm.adm2}, ${sm.adm1}`,
          levelLabel: "Sub-municipality",
          searchText: `${sm.adm2}, ${sm.adm1}, Timor-Leste`,
        }));
        const sucos = sucosRes.data.map((su) => ({
          label: `${su.adm3}, ${su.adm2}, ${su.adm1}`,
          levelLabel: "Suco",
          searchText: `${su.adm3}, ${su.adm2}, ${su.adm1}, Timor-Leste`,
        }));
        setLocationSuggestions([...municipalities, ...subMunicipalities, ...sucos]);
      })
      .catch((error) => console.error("Error loading location suggestions:", error));
  }, []);
  useEffect(() => {
    const map = L.map("map").setView([-8.9747, 125.5275], 8);
    mapRef.current = map;
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 19,
    }).addTo(map);
    // Fetch health facilities from API
    axios.get(`${backendUrl}roadaccident/get_hospital_details/`)
      .then((response) => setHealthFacilities(response.data))
      .catch((error) => console.error("Error loading health facilities:", error));
    // Fetch weather forecast data from the currently active forecast source
    // (same forecastmodels/get-alert/ API the main dashboard's Forecast Map
    // uses), so this always reflects the latest available run for today.
    const suco_variableMap = { rainfall: "tp", max_temp: "heat", min_temp: "cold", humidity: "thi" };
    Promise.all(
      Object.entries(suco_variableMap).map(([key, varName]) =>
        fetch(`${backendUrl}forecastmodels/get-alert/?variable=${varName}&admin_level=3`)
          .then(async (response) => {
            const body = await response.json();
            if (!response.ok) {
              throw new Error(body?.error || `Request failed with status ${response.status}`);
            }
            return { key, data: body?.data || {} };
          })
          .catch((error) => {
            console.error(`Error loading ${key} forecast (variable=${varName}):`, error.message || error);
            return { key, data: null };
          })
      )
    ).then((results) => {
      const combined = {};
      results.forEach(({ key, data }) => {
        if (data) combined[key] = data;
      });
      setWeatherData(combined);
    });
    // Fetch suco GeoJSON
    fetch("/DATA/OSMbased_adm3_boundary.json")
      .then((response) => response.json())
      .then((data) => setSucoGeoJSON(data))
      .catch((error) => console.error("Error loading suco GeoJSON:", error));
    return () => {
      if (mapRef.current) {
        mapRef.current.remove();
      }
    };
  }, []);
  // Plot the real active events (last 24h) on the map so they're visible
  // regardless of whether a route has been searched yet.
  useEffect(() => {
    if (!mapRef.current) return;
    if (activeEventsLayerRef.current) {
      mapRef.current.removeLayer(activeEventsLayerRef.current);
      activeEventsLayerRef.current = null;
    }
    const layerGroup = L.layerGroup().addTo(mapRef.current);
    activeEventsLayerRef.current = layerGroup;
    activeEvents.forEach((event) => {
      const point = event.geometry?.type === "Point"
        ? [event.geometry.coordinates[1], event.geometry.coordinates[0]]
        : (event.lat != null && event.lon != null ? [event.lat, event.lon] : null);
      if (!point) return;
      const locationName = [event.suco, event.sub_municipality, event.municipality].filter(Boolean).join(", ") || "Unknown location";
      L.circleMarker(point, {
        radius: 8,
        color: "#dc3545",
        weight: 2,
        fillColor: "#dc3545",
        fillOpacity: 0.6,
      })
        .bindPopup(
          `<strong>${event.event || "Active event"}</strong><br>${event.description || ""}<br><strong>Location:</strong> ${locationName}${event.advisory ? `<br><strong>Advisory:</strong> ${event.advisory}` : ""}`
        )
        .addTo(layerGroup);
    });
  }, [activeEvents]);
  // Today's forecast value for a given admCode/parameter: index 0 of the
  // active source's period array is always "today" for whichever forecast
  // run is currently active, so no separate date computation is needed.
  const getTodayValue = useCallback((param, admCode) => {
    const records = weatherData[param]?.[admCode?.toString()];
    return Array.isArray(records) && records.length > 0 ? records[0].aggregate_value : null;
  }, [weatherData]);
  const getWeatherColor = useCallback((admCode, param) => {
    const max_temp = getTodayValue("max_temp", admCode);
    const min_temp = getTodayValue("min_temp", admCode);
    const rainfall = getTodayValue("rainfall", admCode);
    const humidity = getTodayValue("humidity", admCode);
    if (param === "max_temp") {
      return max_temp != null && max_temp > 30 ? "red" : "transparent";
    } else if (param === "min_temp") {
      return min_temp != null && min_temp < 10 ? "blue" : "transparent";
    } else if (param === "rainfall") {
      return rainfall != null && rainfall > 3 ? "purple" : "transparent";
    } else if (param === "humidity") {
      return humidity != null && humidity > 30 ? "teal" : "transparent";
    } else if (param === "combined") {
      if (max_temp != null && max_temp > 30) return "red";
      if (min_temp != null && min_temp < 10) return "blue";
      if (rainfall != null && rainfall > 3) return "purple";
      if (humidity != null && humidity > 30) return "teal";
      return "transparent";
    }
    return "transparent";
  }, [getTodayValue]);
  const addSucoWeatherLayer = useCallback(() => {
    if (sucoLayerRef.current && mapRef.current) {
      mapRef.current.removeLayer(sucoLayerRef.current);
    }
    const layerToParam = {
      heatwave: "max_temp",
      coldwave: "min_temp",
      rainfall: "rainfall",
      humidity: "humidity",
      combined: "combined",
    };
    const param = layerToParam[selectedWeatherLayer];
    sucoLayerRef.current = L.geoJSON(sucoGeoJSON, {
      style: (feature) => {
        const admCode = feature.properties.ADM_Code.toString();
        const color = getWeatherColor(admCode, param);
        return {
          fillColor: color,
          fillOpacity: color === "transparent" ? 0 : 0.7,
          color: "transparent",
          weight: 0,
          opacity: 0,
        };
      },
      onEachFeature: (feature, layer) => {
        const admCode = feature.properties.ADM_Code.toString();
        const rainfall = getTodayValue("rainfall", admCode);
        const max_temp = getTodayValue("max_temp", admCode);
        const min_temp = getTodayValue("min_temp", admCode);
        const humidity = getTodayValue("humidity", admCode);
        if (rainfall != null || max_temp != null || min_temp != null || humidity != null) {
          const tooltipContent = `
            <b>Suco: ${feature.properties.ADM3}</b><br>
            Rainfall: ${rainfall ?? "-"} mm<br>
            Max Temp: ${max_temp ?? "-"} °C<br>
            Min Temp: ${min_temp ?? "-"} °C<br>
            Humidity: ${humidity ?? "-"} %
          `;
          layer.bindTooltip(tooltipContent, { sticky: true });
        }
      },
    }).addTo(mapRef.current);
  }, [sucoGeoJSON, getTodayValue, selectedWeatherLayer, getWeatherColor]);
  useEffect(() => {
    const hasWeatherData = Object.keys(weatherData).length > 0;
    if (sucoGeoJSON && hasWeatherData && mapRef.current && selectedWeatherLayer !== "none") {
      addSucoWeatherLayer();
    } else if (sucoLayerRef.current && mapRef.current) {
      mapRef.current.removeLayer(sucoLayerRef.current);
      sucoLayerRef.current = null;
    }
  }, [selectedWeatherLayer, sucoGeoJSON, weatherData, addSucoWeatherLayer]);
  useEffect(() => {
    if (mapRef.current) {
      mapRef.current.invalidateSize();
    }
  }, [showInfoPanel]);
  const geocode = async (location) => {
    const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(location)}`;
    try {
      const response = await fetch(url);
      const data = await response.json();
      return data.length > 0 ? { lat: parseFloat(data[0].lat), lon: parseFloat(data[0].lon) } : null;
    } catch (error) {
      console.error("Geocoding error:", error);
      return null;
    }
  };
  const findRoute = async () => {
    if (!mapRef.current) return;
    try {
      const startCoords = await geocode(startLocation);
      const endCoords = await geocode(endLocation);
      if (!startCoords || !endCoords) throw new Error("Invalid locations");
      // Clear existing layers
      if (routeLayerRef.current && mapRef.current) mapRef.current.removeLayer(routeLayerRef.current);
      if (eventSegmentRef.current && mapRef.current) mapRef.current.removeLayer(eventSegmentRef.current);
      if (routingControlRef.current && mapRef.current) mapRef.current.removeControl(routingControlRef.current);
      if (hospitalLayerRef.current && mapRef.current) mapRef.current.removeLayer(hospitalLayerRef.current);
      setRouteInfo(null);
      setEventInfo(null);
      setWeatherWarnings([]);
      setNearbyHospitals([]);
      setShowHospitals(false);
      setShowInfoPanel(true);
      generateRoute(startCoords, endCoords);
    } catch (error) {
      alert(error.message);
    }
  };
  const generateRoute = async (start, end) => {
    const control = L.Routing.control({
      waypoints: [L.latLng(start.lat, start.lon), L.latLng(end.lat, end.lon)],
      routeWhileDragging: false,
      draggableWaypoints: false,
      addWaypoints: false,
      lineOptions: {
        styles: [{ color: "blue", weight: 4 }]
      },
      createMarker: function(i, wp, n) {
        let iconUrl;
        if (i === 0) {
          iconUrl = "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png";
        } else if (i === n - 1) {
          iconUrl = "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png";
        } else {
          iconUrl = "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png";
        }
        const icon = L.icon({
          iconUrl: iconUrl,
          iconSize: [25, 41],
          iconAnchor: [12, 41],
          shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
          shadowSize: [41, 41],
        });
        return L.marker(wp.latLng, { icon: icon, draggable: false });
      },
    }).addTo(mapRef.current);
    routingControlRef.current = control;
    control.on("routesfound", async (e) => {
      const routeCoords = e.routes[0].coordinates.map((coord) => [coord.lng, coord.lat]);
      const routeLine = turf.lineString(routeCoords);
      setRouteGeoJSON(routeLine);
      const totalDistance = turf.length(routeLine, { units: "kilometers" }).toFixed(2);
      let eventData = null;
      for (const event of activeEvents) {
        const eventArea = buildEventArea(event, turf);
        if (!eventArea) continue;
        if (turf.booleanIntersects(routeLine, eventArea)) {
          const intersectPoints = turf.lineIntersect(routeLine, eventArea);
          if (intersectPoints.features.length >= 2) {
            const entryUrl = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${intersectPoints.features[0].geometry.coordinates[1]}&lon=${intersectPoints.features[0].geometry.coordinates[0]}`;
            const exitUrl = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${intersectPoints.features[1].geometry.coordinates[1]}&lon=${intersectPoints.features[1].geometry.coordinates[0]}`;
            const [entryResponse, exitResponse] = await Promise.all([fetch(entryUrl), fetch(exitUrl)]);
            const entryData = await entryResponse.json();
            const exitData = await exitResponse.json();
            const entryPlaceName = entryData.display_name || "Unknown location";
            const exitPlaceName = exitData.display_name || "Unknown location";
            const startToEventDistance = turf.distance(
              turf.point([start.lon, start.lat]),
              turf.point(intersectPoints.features[0].geometry.coordinates),
              { units: "kilometers" }
            ).toFixed(2);
            const eventLocationName = [event.suco, event.sub_municipality, event.municipality].filter(Boolean).join(", ") || "the reported location";
            eventData = {
              name: event.event || "Active Event",
              description: event.description || `An active ${event.event || "hazard"} event was reported near ${eventLocationName} in the last 24 hours.`,
              entry: intersectPoints.features[0].geometry.coordinates,
              exit: intersectPoints.features[1].geometry.coordinates,
              entryPlace: entryPlaceName,
              exitPlace: exitPlaceName,
              travelDistance: turf.distance(
                turf.point(intersectPoints.features[0].geometry.coordinates),
                turf.point(intersectPoints.features[1].geometry.coordinates),
                { units: "kilometers" }
              ).toFixed(2),
              startToEventDistance: startToEventDistance,
              totalDistance: totalDistance,
            };
            break;
          }
        }
      }
      // Consolidate weather warnings by type, using today's value from the
      // currently active forecast source (same data as the weather map layer).
      const warnings = { heatwave: [], coldwave: [], rainfall: [], humidity: [] };
      if (sucoGeoJSON) {
        const intersectingSucos = sucoGeoJSON.features.filter((feature) =>
          turf.booleanIntersects(routeLine, turf.feature(feature.geometry))
        );
        intersectingSucos.forEach((suco) => {
          const admCode = suco.properties.ADM_Code.toString();
          const maxTemp = getTodayValue("max_temp", admCode);
          const minTemp = getTodayValue("min_temp", admCode);
          const rainfall = getTodayValue("rainfall", admCode);
          const humidity = getTodayValue("humidity", admCode);
          if (maxTemp != null && maxTemp > 30) {
            warnings.heatwave.push(suco.properties.ADM3);
          }
          if (minTemp != null && minTemp < 10) {
            warnings.coldwave.push(suco.properties.ADM3);
          }
          if (rainfall != null && rainfall > 3) {
            warnings.rainfall.push(suco.properties.ADM3);
          }
          if (humidity != null && humidity > 30) {
            warnings.humidity.push(suco.properties.ADM3);
          }
        });
      }
      const formattedWarnings = Object.keys(warnings).map((type) => {
        if (warnings[type].length > 0) {
          return {
            type,
            message: `${type.charAt(0).toUpperCase() + type.slice(1)} alert across the regions of ${warnings[type].join(", ")}`,
            icon: type === "heatwave" ? Thermometer : type === "coldwave" ? Snowflake : type === "rainfall" ? CloudRain : Droplets,
          };
        }
        return null;
      }).filter(Boolean);
      setWeatherWarnings(formattedWarnings);
      // Calculate nearby hospitals with 200m buffer
      let nearby = [];
      if (healthFacilities.length > 0) {
        nearby = healthFacilities.filter((hospital) => {
          const parsedLat = parseFloat(hospital.latitude);
          const parsedLon = parseFloat(hospital.longitude);
          if (isNaN(parsedLat) || isNaN(parsedLon)) return false;
          const hospitalPoint = turf.point([parsedLon, parsedLat]);
          const hospitalBuffer = turf.buffer(hospitalPoint, 0.2, { units: "kilometers" });
          return turf.booleanIntersects(hospitalBuffer, routeLine);
        });
        setNearbyHospitals(nearby);
      }
      setRouteInfo({ startLocation, endLocation, totalDistance });
      if (eventData) {
        setEventInfo(eventData);
        eventSegmentRef.current = L.polyline([eventData.entry.reverse(), eventData.exit.reverse()], {
          color: "blue",
          weight: 4,
        }).addTo(mapRef.current);
      } else {
        setEventInfo(null);
      }
      routeLayerRef.current = L.polyline(routeCoords.map(([lng, lat]) => [lat, lng]), {
        color: "blue",
        weight: 4,
      }).addTo(mapRef.current);
    });
  };
  const toggleHospitals = () => {
    if (hospitalLayerRef.current && mapRef.current) {
      mapRef.current.removeLayer(hospitalLayerRef.current);
      hospitalLayerRef.current = null;
    }
    const newShowHospitals = !showHospitals;
    setShowHospitals(newShowHospitals);
    if (newShowHospitals) {
      const markers = nearbyHospitals.map((hospital) => {
        const parsedLat = parseFloat(hospital.latitude);
        const parsedLon = parseFloat(hospital.longitude);
        if (isNaN(parsedLat) || isNaN(parsedLon)) return null;
        return L.marker([parsedLat, parsedLon], {
          icon: L.icon({
            iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-yellow.png",
            iconSize: [25, 41],
            iconAnchor: [12, 41],
            shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
            shadowSize: [41, 41],
          })
        });
      }).filter(marker => marker !== null);
      hospitalLayerRef.current = L.layerGroup(markers).addTo(mapRef.current);
    }
  };
  const containerStyle = {
    display: "flex",
    flexDirection: "row",
    height: "76vh",
    gap: "5px",
  };
  const mapStyle = {
    flex: "1 0 60%",
    borderRadius: "8px",
    overflow: "hidden",
  };
  const rightPanelStyle = {
    flex: "1 0 40%",
    display: "flex",
    flexDirection: "column",
    gap: "5px",
    height: "100%",
  };
  const formStyle = {
    backgroundColor: "white",
    padding: "15px",
    borderRadius: "8px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  };
  const infoPanelStyle = {
    flexGrow: 1,
    background: "rgba(255, 255, 255, 0.9)",
    backdropFilter: "blur(12px) brightness(1.1)",
    WebkitBackdropFilter: "blur(12px) brightness(1.1)",
    border: "1px solid rgba(0, 0, 0, 0.08)",
    color: "#333333",
    borderRadius: "12px",
    boxShadow: "0 4px 16px rgba(0, 0, 0, 0.15), inset 0 1px 2px rgba(255, 255, 255, 0.5)",
    fontFamily: "'Inter', sans-serif",
    overflowY: "auto",
    padding: "20px",
  };
  const sectionStyle = {
    marginBottom: "20px",
    paddingBottom: "10px",
    borderBottom: "1px solid #eee",
  };
  const titleStyle = {
    fontWeight: "600",
    fontSize: "1.2em",
    marginBottom: "12px",
    color: "#333",
  };
  const contentStyle = {
    fontSize: "0.9em",
    color: "#555",
    lineHeight: "1.5",
  };
  const inputStyle = {
    borderRadius: "6px",
    border: "1px solid #ced4da",
    padding: "10px",
    fontSize: "0.9em",
  };
  const buttonStyle = {
    borderRadius: "6px",
    padding: "10px",
    fontSize: "0.9em",
    backgroundColor: "#007bff",
    border: "none",
    transition: "background-color 0.2s",
  };
  return (
    <div className="mapcontainerall" style={{ padding: "20px", backgroundColor: "#f8f9fa", borderRadius: "8px" }}>
      <div style={containerStyle}>
        <div id="map" style={mapStyle}></div>
        <div style={rightPanelStyle}>
          <div style={formStyle}>
            <Form>
              <Row className="align-items-center">
                <Col md={6} style={{ marginBottom: "10px" }}>
                  <LocationAutosuggest
                    value={startLocation}
                    onChange={setStartLocation}
                    placeholder="Start Location"
                    suggestions={locationSuggestions}
                    style={inputStyle}
                  />
                </Col>
                <Col md={6} style={{ marginBottom: "10px" }}>
                  <LocationAutosuggest
                    value={endLocation}
                    onChange={setEndLocation}
                    placeholder="End Location"
                    suggestions={locationSuggestions}
                    style={inputStyle}
                  />
                </Col>
                <Col md={6}>
                  <Form.Select
                    value={selectedWeatherLayer}
                    onChange={(e) => setSelectedWeatherLayer(e.target.value)}
                    style={{ ...inputStyle, marginBottom: "10px" }}
                  >
                    <option value="none">No Weather Layer</option>
                    <option value="heatwave">Heatwave Layer</option>
                    <option value="coldwave">Cold Wave Layer</option>
                    <option value="rainfall">Rainfall Layer</option>
                    <option value="humidity">Humidity Layer</option>
                    <option value="combined">Combined Weather Layer</option>
                  </Form.Select>
                </Col>
                <Col md={6}>
                  <Button
                    variant="primary"
                    onClick={findRoute}
                    style={{ ...buttonStyle, width: "100%" }}
                    onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#0056b3")}
                    onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#007bff")}
                  >
                    Find Route
                  </Button>
                </Col>
              </Row>
            </Form>
          </div>
          {showInfoPanel && (
            <div style={infoPanelStyle}>
              {routeInfo && (
                <div style={sectionStyle}>
                  <div style={titleStyle}>Route Information</div>
                  <p style={contentStyle}>
                    {routeInfo.startLocation} → {routeInfo.endLocation}<br />
                    Total Distance: {routeInfo.totalDistance} km
                  </p>
                </div>
              )}
              {eventInfo && (
                <div style={sectionStyle}>
                  <div style={titleStyle}>Event Alert — {eventInfo.name}</div>
                  <p style={contentStyle}>
                    {eventInfo.description}<br />
                    Distance to Event: {eventInfo.startToEventDistance} km<br />
                    Affected Path: {eventInfo.entryPlace} - {eventInfo.exitPlace}<br />
                    Distance Through Event: {eventInfo.travelDistance} km
                  </p>
                </div>
              )}
              {weatherWarnings.length > 0 && (
                <div style={sectionStyle}>
                  <div style={titleStyle}>Weather Alerts Along Route</div>
                  {weatherWarnings.map((warning, index) => (
                    <p key={index} style={contentStyle}>
                      <warning.icon size={16} style={{ marginRight: "8px", verticalAlign: "middle", color: "#555" }} />
                      {warning.message}
                    </p>
                  ))}
                </div>
              )}
              {nearbyHospitals.length > 0 && (
                <div style={sectionStyle}>
                  <div style={titleStyle}>Nearby Hospitals ({nearbyHospitals.length})</div>
                  <FormCheck
                    type="checkbox"
                    label="Show on Map"
                    checked={showHospitals}
                    onChange={toggleHospitals}
                    style={{ fontSize: "0.9em", color: "#555" }}
                  />
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default AssistanceOnMove;